/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDefinitionSubjectMatterExpertKey { 
    /**
     * The namespace of the Business Object Definition
     */
    namespace: string;
    /**
     * The name of the Business Object Definition
     */
    businessObjectDefinitionName: string;
    /**
     * The user id of the Subject Matter Expert
     */
    userId: string;
}
